/* eslint-disable no-unused-vars */
import React, {Component} from "react";
import {InputLabel, withStyles, Select, MenuItem} from "@material-ui/core";
import classNames from 'classnames';
import FormControl from '@material-ui/core/FormControl';
import {API} from "../../../config";
import Util from "../../../yeffect/utils";

const country = API.service('country');

const styles = theme => ({
    input: {
        width: '100%',
    },
    wrapper:{
        paddingLeft:'8px',
        paddingRight:'8px'
    }
});

class CountrySelect extends Component {
    state = {
        active:     this.props.active || 1,
        countries:  false,
        options:    false,
    };

    updateOptions = () => {
        const app = this;

        let options = [];

        if(this.props.categoryValue === 'E'){

            if(this.props.groupValue === 'S'
                || this.props.groupValue === 'C'
                || this.props.groupValue === 'L'
            ) {
                options.push(
                    {value: 'O', label: 'O: Nil Paid'},
                    {value: 'P', label: 'P: Partly Paid'},
                    {value: 'F', label: 'F: Fully Paid'},
                )
            }

            if(this.props.groupValue === 'P'
                || this.props.groupValue === 'F'
                || this.props.groupValue === 'D'
            ) {
                options.push(
                    {value: 'F', label: 'F: Fixed Rate Income'},
                    {value: 'C', label: 'C: Cumulative, Fixed Rate Income'},
                    {value: 'P', label: 'P: Participating Income'},
                    {value: 'Q', label: 'Q: Cumulative, Participating Income'},
                    {value: 'A', label: 'A: Adjustable/Variable Rate Income'},
                    {value: 'N', label: 'N: Normal Rate Income'},
                    {value: 'U', label: 'U: Auction Rate Income'},
                    {value: 'D', label: 'D: Dividends'},
                )
            }



            if(this.props.groupValue === 'Y') {
                options.push(
                    {value: 'F', label: 'F: Cash Repayment'},
                    {value: 'V', label: 'V: Physical Repayment'},
                    {value: 'E', label: 'E: Elect at Settlement'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'M') {
                options.push(
                    {value: 'X', label: 'X: Not Applicable/Undefined'},
                )
            }
        }

        if(this.props.categoryValue === 'D'){

            if(this.props.groupValue === 'B'
            ){
                options.push(
                    {value: 'F', label: 'F: Fixed Maturity'},
                    {value: 'G', label: 'G: Fixed Maturity with Call Feature'},
                    {value: 'C', label: 'C: Fixed Maturity with Put Feature'},
                    {value: 'D', label: 'D: Fixed Maturity with Put and Call'},
                    {value: 'A', label: 'A: Amortization Plan'},
                    {value: 'B', label: 'B: Amortization Plan with Call Feature'},
                    {value: 'T', label: 'T: Amortization Plan with Put Feature'},
                    {value: 'L', label: 'L: Amortization Plan with Put and Call'},
                    {value: 'P', label: 'P: Perpetual'},
                    {value: 'Q', label: 'Q: Perpetual with Call Feature'},
                    {value: 'R', label: 'R: Perpetual with Put Feature'},
                )
            }

            if(this.props.groupValue === 'C'
                || this.props.groupValue === 'W'
                || this.props.groupValue === 'T'
                || this.props.groupValue === 'G'
                || this.props.groupValue === 'A'
                || this.props.groupValue === 'N'
            ) {
                options.push(
                    {value: 'F', label: 'F: Fixed Maturity'},
                    {value: 'G', label: 'G: Fixed Maturity with Call Feature'},
                    {value: 'C', label: 'C: Fixed Maturity with Put Feature'},
                    {value: 'D', label: 'D: Fixed Maturity with Put and Call'},
                    {value: 'A', label: 'A: Amortization Plan'},
                    {value: 'B', label: 'B: Amortization Plan with Call Feature'},
                    {value: 'T', label: 'T: Amortization Plan with Put Feature'},
                    {value: 'L', label: 'L: Amortization Plan with Put and Call'},
                    {value: 'P', label: 'P: Perpetual'},
                    {value: 'Q', label: 'Q: Perpetual with Call Feature'},
                    {value: 'R', label: 'R: Perpetual with Put Feature'},
                    {value: 'E', label: 'E: Extendible'},
                )
            }
            if(this.props.groupValue === 'S'
            ){
                options.push(
                    {value: 'F', label: 'F: Fixed Cash Repayment (Only Protected Capital Level)'},
                    {value: 'V', label: 'V: Variable Cash Repayment'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'E'
            ){
                options.push(
                    {value: 'R', label: 'R: Repayment in Cash'},
                    {value: 'S', label: 'S: Repayment in Assets'},
                    {value: 'C', label: 'C: Repayment in Assets and Cash'},
                    {value: 'T', label: 'T: Repayment in Assets or Cash'},
                    {value: 'M', label: 'M: Others(Miscellaneous)'},
                )
            }

            if(this.props.groupValue === 'D') {
                options.push(
                    {value: 'T', label: 'T: Government/State Guarantee'},
                    {value: 'G', label: 'G: Joint Guarantee'},
                    {value: 'S', label: 'S: Secured'},
                    {value: 'U', label: 'U: Unsecured/Unguaranteed'},
                    {value: 'P', label: 'P: Negative Pledge'},
                    {value: 'N', label: 'N: Senior'},
                    {value: 'O', label: 'O: Senior Subordinated'},
                    {value: 'Q', label: 'Q: Junior'},
                    {value: 'J', label: 'J: Junior Subordinated'},
                    {value: 'C', label: 'C: Supranational'},
                )
            }

            if(this.props.groupValue === 'M'
                || this.props.groupValue === 'Y'

            ) {
                options.push(
                    {value: 'X', label: 'X: Not Applicable/Undefined'},
                )
            }
        }

        if(this.props.categoryValue === 'C'){

            if(this.props.groupValue === 'I'
                || this.props.groupValue === 'E'
                || this.props.groupValue === 'P'
            ) {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value: 'R', label: 'R: Real Estate'},
                        {value: 'B', label: 'B: Debt Instruments'},
                        {value: 'E', label: 'E: Equities'},
                        {value: 'V', label: 'V: Convertible Securities'},
                        {value: 'L', label: 'L: Mixed'},
                        {value: 'C', label: 'C: Commodities'},
                        {value: 'D', label: 'D: Derivatives'},
                        {value: 'F', label: 'F: Referential Instruments'},
                        {value: 'K', label: 'K: Credits'},
                        {value: 'M', label: 'M: Others'},
                    )
                }
            }

            if(this.props.groupValue === 'H'
                || this.props.groupValue === 'B'
                || this.props.groupValue === 'M'
            ) {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'X',label:'X: Not Applicable/Undefined'}
                    )
                }
            }

            if(this.props.groupValue === 'S') {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'R',label:'R: Defined Benefit'},
                        {value:'B',label:'B: Defined Contribution'},
                        {value:'M',label:'M: Others (Miscellaneous)'},
                    )
                }
            }

            if(this.props.groupValue === 'F') {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'I',label:'I: Standard (Vanilla)'},
                        {value:'H',label:'H: Hedge Funds'},
                        {value:'B',label:'B: REIT'},
                        {value:'E',label:'E: ETF'},
                        {value:'P',label:'P: Private Equity Funds'},
                        {value:'M',label:'M: Others (Miscellaneous)'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'R'){

            if(this.props.groupValue === 'W') {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'C',label:'C: Call'},
                        {value:'P',label:'P: Put'},
                        {value:'B',label:'B: Call and Put'},
                    )
                }
            }

            if(this.props.groupValue === 'F') {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'C',label:'C: Long'},
                        {value:'P',label:'P: Short'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }

            if(this.props.groupValue === 'A'
                || this.props.groupValue === 'S'
                || this.props.groupValue === 'P'
                || this.props.groupValue === 'D'
                || this.props.groupValue === 'M'
            ) {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'X',label:'X: Not Applicable/Undefined'}
                    )
                }
            }
        }

        if(this.props.categoryValue === 'O'){

            if(this.props.groupValue === 'C'
                || this.props.groupValue === 'P'
            ) {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'P',label:'P: Physical'},
                        {value:'C',label:'C: Cash'},
                        {value:'N',label:'N: Non-Deliverable'},
                        {value:'E',label:'E: Elect at Exercise'},
                    )
                }
            }

            if(this.props.groupValue === 'M') {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'X',label:'X: Not Applicable/Undefined'}
                    )
                }
            }
        }

        if(this.props.categoryValue === 'F'){

            if(this.props.groupValue === 'F'
                || this.props.groupValue === 'C'
            ) {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'S',label:'S: Standardized'},
                        {value:'N',label:'N: Non-Standardized'},
                    )
                }
            }
        }

        if(this.props.categoryValue === 'T'){

            if(this.props.groupValue === 'I'
                || this.props.groupValue === 'P'
            ) {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'P',label:'P: Price Return'},
                        {value:'N',label:'N: Net Total Return'},
                        {value:'G',label:'G: Gross Total Return'},
                        {value:'M',label:'M: Others(Miscellaneous)'},
                    )
                }
            }

            if(this.props.groupValue === 'C'
                || this.props.groupValue === 'T'
                || this.props.groupValue === 'R'
                || this.props.groupValue === 'B'
                || this.props.groupValue === 'D'
                || this.props.groupValue === 'M'
            ) {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'X',label:'X: Not Applicable/Undefined'}
                    )
                }
            }
        }

        if(this.props.categoryValue === 'M'){
            if(this.props.groupValue === 'C'
                || this.props.groupValue === 'M'
            ) {
                if(this.props.lvl2Value !== '') {
                    options.push(
                        {value:'X',label:'X: Not Applicable/Undefined'}
                    )
                }
            }
        }

        app.setState({
            options: options
        })
    }

    componentDidMount() {
        this.updateOptions();
    }

    componentDidUpdate(prevProps, prevState, prevContext) {
        if(this.props.categoryValue !== prevProps.categoryValue || this.props.groupValue !== prevProps.groupValue){
            this.updateOptions();
        }
    }

    render() {
        const { classes, possibleValues, value, width, onChange, fieldLabel, fieldName, errorFields, categoryValue} = this.props;
        const { active } = this.state;

        return (
            <React.Fragment>
                <div className={classNames(classes.wrapper,width)}>

                    <FormControl className={classNames('w-full')} >
                        <InputLabel shrink={(!Util.isEmpty(value) || value === false)} id={fieldName + '_label'}>{fieldLabel} {(this.props.required === true) ? '*' :''}</InputLabel>
                        <Select
                            labelId={fieldName + '_label'}
                            id={fieldName}
                            value={value}
                            label="Age"
                            name={fieldName}
                            onChange={onChange}
                            error={!(typeof errorFields[fieldName] === "undefined")}
                            helperText={(typeof errorFields[fieldName] !== "undefined") ? errorFields[fieldName] : false}
                            required={this.props.required}
                            >


                            <option value=""> </option>
                            {(this.state.options !== false) &&
                            this.state.options.map(o => {
                                return (
                                    <MenuItem value={o.value}>{o.label}</MenuItem>
                                )

                            })
                            }
                        </Select>
                    </FormControl>

                </div>
            </React.Fragment>
        );
    }
}

export default withStyles(styles, { withTheme: true })(CountrySelect);



// WEBPACK FOOTER //
// ./src/yeffect/formBuilder/components/CFILevel3Select.js